<div class="container-fluid animated fadeIn">
	<div class="row mt-5 mb-5">
		<!-- TITLES AND BUTTONS AREA -->
		<div class="col-xl-12">
			<div class="d-flex align-items-baseline justify-content-between top-area">
				<!-- Page title -->
				<div class="title-area">
					<div>
						<h2 class="mb-0">{{ 'private-home.pageTitle' | translate }}</h2>
					</div>
				</div>
				<!-- link new features-->
				<div class="d-flex align-items-center mt-2 mt-xl-0">
					<span [innerHTML]="newFeatureHtml"></span>
				</div>
			</div>
		</div>

		<!-- BANNER -->
		<!-- Supplier has this information on its dashboard, because of location purposes -->
		@if (false) {
			<div class="col-xl-6 mt-3">
				<a
					target="_blank"
					href="https://info.saphety.com/flexcash/factoring-faturacao-eletronica">
					@if (loggedUser?.LanguageCode === 'pt') {
						<img
							class="img-fluid"
							src="assets/images/banner-factoring_PT.jpg"
							alt="Banner-Factoring" />
					}
					@if (loggedUser?.LanguageCode !== 'pt') {
						<img
							class="img-fluid"
							src="assets/images/banner-factoring_EN.jpg"
							alt="Banner-Factoring" />
					}
				</a>
			</div>
		}

		<!-- CONTENT -->
		<div class="col-xl-12">
			@if (loggedUser?.IsSupplier && !loggedUser?.IsBuyer && !loggedUser?.IsFinancier) {
				<app-dashboard-supplier></app-dashboard-supplier>
			}
			@if (!loggedUser?.IsSupplier && loggedUser?.IsBuyer && !loggedUser?.IsFinancier) {
				<app-dashboard-buyer></app-dashboard-buyer>
			}
			@if (!loggedUser?.IsSupplier && !loggedUser?.IsBuyer && loggedUser?.IsFinancier) {
				<app-dashboard-financier></app-dashboard-financier>
			}
			@if (loggedUser?.IsSystemAdmin) {
				<app-dashboard-administrator> </app-dashboard-administrator>
			}
			@if (loggedUser?.IsSupportOperator) {
				<app-dashboard-support-operator> </app-dashboard-support-operator>
			}
			@if (loggedUser?.IsBackOfficeOperator) {
				<app-dashboard-backoffice-operator> </app-dashboard-backoffice-operator>
			}
		</div>
	</div>
</div>
